module.exports = __webpack_public_path__ + "img/42.d79f3da6.png";